import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SuppressLinkUnderlineContext = /*#__PURE__*/createContext({
  suppressUnderline: false
});
export const SuppressLinkUnderlineContextProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(SuppressLinkUnderlineContext.Provider, {
    value: props,
    children: children
  });
};
export const useSuppressLinkUnderlineContext = () => {
  return useContext(SuppressLinkUnderlineContext);
};